import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import { useTemplateColors } from 'PDF/TemplateEngine/TemplateColorsContext';
import { replaceVariables } from 'PDF/TemplateEngine/utils/replaceVariables';
import StatusTag from 'PDF/TemplateEngine/atoms/StatusTag';

// Body type 'title-band': h1 + subtítulo + tag de estado opcional.
function TitleBandSection({ section, data }) {
  const { colors, FONT } = useTemplateColors();
  const cfg = section?.config || {};
  const styles = StyleSheet.create({
    band: { flexDirection: 'row', alignItems: 'center', gap: '0.3cm' },
    left: { flex: 1 },
    h1: { fontSize: 18, fontFamily: FONT.bold, color: colors.ink || colors.darkText },
    sub: { fontSize: 9, fontFamily: FONT.base, color: colors.muted, marginTop: '0.08cm' },
  });
  const tag = cfg.tag;
  return (
    <View style={styles.band}>
      <View style={styles.left}>
        <Text style={styles.h1}>{replaceVariables(cfg.h1 || '', data || {})}</Text>
        {cfg.sub ? <Text style={styles.sub}>{replaceVariables(cfg.sub, data || {})}</Text> : null}
      </View>
      {tag?.text ? (
        <StatusTag tone={tag.tone}>{replaceVariables(tag.text, data || {})}</StatusTag>
      ) : null}
    </View>
  );
}

export default TitleBandSection;
